import { z } from 'zod';

import {
  PurchaseDraftSchema,
  PurchaseLineEntrySchema,
  PurchaseTotalsSchema,
} from './purchases.schema.js';
import type {
  ChangePurchaseDraftLinesMaterialRequest,
  ChangePurchaseDraftLinesMaterialResponse,
  PurchaseDraftLinesMaterialChangePreview,
} from './purchases-draft-change-material.dto.js';

export const PurchaseDraftLinesMaterialChangePreviewSchema: z.ZodType<PurchaseDraftLinesMaterialChangePreview> =
  z.object({
    beforeTotals: PurchaseTotalsSchema,
    afterTotals: PurchaseTotalsSchema,
    beforeLineItems: z.array(PurchaseLineEntrySchema),
    afterLineItems: z.array(PurchaseLineEntrySchema),
  });

export const ChangePurchaseDraftLinesMaterialRequestSchema: z.ZodType<ChangePurchaseDraftLinesMaterialRequest> =
  z
    .object({
      companyId: z.uuid(),
      storeId: z.uuid(),
      locationId: z.uuid(),
      stationId: z.uuid(),
      laneId: z.string().trim().min(1).max(64).nullable().optional(),
      draftId: z.uuid(),
      targetMaterialId: z.uuid(),
      lineIds: z.array(z.uuid()).min(1).optional(),
      sourceMaterialId: z.uuid().optional(),
      preview: z.boolean().optional(),
    })
    .superRefine((value, ctx) => {
      const hasLineIds = Array.isArray(value.lineIds) && value.lineIds.length > 0;
      const hasSourceMaterialId = Boolean(value.sourceMaterialId);

      if (hasLineIds === hasSourceMaterialId) {
        ctx.addIssue({
          code: 'custom',
          message: 'Provide either lineIds or sourceMaterialId.',
        });
      }
    });

export const ChangePurchaseDraftLinesMaterialResponseSchema: z.ZodType<ChangePurchaseDraftLinesMaterialResponse> =
  z.object({
    draft: PurchaseDraftSchema,
    preview: PurchaseDraftLinesMaterialChangePreviewSchema.optional(),
  });
